import React, { useState, useEffect } from 'react';
import { Page, BackButton } from 'react-onsenui';
import { InputItem, List, Button, Modal } from 'antd-mobile';
import './Connexion.css';
import CryptoJS from 'crypto-js';
import axios from 'axios'; 
import { API_FFF_HOST, SSO_HOST } from '../../config.env';
import { useHistory } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { initializeConnexion } from '../../actions/connexionActions';
import { connect } from 'react-redux';

const Connexion = props => {
    const access = props.connexionReducer;
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [onSubmit, setOnSubmit] = useState(false);
    const history = useHistory();

    useEffect(() => {
        if (access && access !== -1) {
            history.push('/matches')
        }
    });

    return (
        <Page
            modifier="lfa-connect"
        >
            <div className="left">
                <BackButton 
                    onClick={() => history.goBack()} 
                    modifier='quiet'
                >
                </BackButton>
            </div>
            <div className="lfa-logo-head">
                <img src={require('../../images/logo-fff-lfa.png')} alt="Foot Amateur" />
            </div>
            <div className="lfa-login-form ion-padding-end">
                <List>
                    <InputItem onChange={setEmail} className="lfa-input" type="email">
                        <span className="lfa-common">Adresse email</span>
                    </InputItem>
                    <InputItem onChange={setPassword} className="lfa-input" type="password">
                        <span className="lfa-common">Mot de passe</span>
                    </InputItem>
                </List>
                <div className="lfa-btn-container">
                    <Button
                        loading={onSubmit}
                        style={{
                            textTransform: 'lowercase', 
                            backgroundImage: 'linear-gradient(to right, #2579BF, #10407F 70%, #0E3A79)', 
                            color: '#ffffff',
                            fontFamily: 'fff-equipe',fontSize: '16px',
                            marginLeft: 20,
                            marginRight: 20
                        }} 
                        disabled={(email === '' || password === '' || onSubmit)}
                        onClick={() => {
                            setOnSubmit(true);
                            signIn(email, password)
                                .then(() => {
                                    props.initializeConnexion();

                                    setTimeout(() => setOnSubmit(false), 3000);
                                })
                                .catch(() => {
                                    setOnSubmit(false);
                                    Modal.alert('FFF', 'Votre identifiant ou mot de passe ne sont pas corrects.', [
                                        {text: <span style={{fontFamily: 'fff-equipe', color: '#000' ,fontWeight: 700, fontSize: 14}}>Annuler</span>}
                                    ])
                                })
                        }}
                    >
                        Se connecter
                    </Button>
                    <div className="lfa-btn-signin lfa-common">
                       <a href={`${SSO_HOST}/oubli-mot-de-passe/`}> Mot de passe oublié ?</a>
                    </div>
                </div>
            </div>
        </Page>
    );
}

function signIn(username, password) {
    const timestamp = Math.floor(Date.now() / 1000);
    const tokenPassword = 'RmZmQXBwbGljYXRpb25GT1NPYXV0aDJFbmNyeXB0aW9uS2V5' + timestamp;
    const text = {
      client_id: '30_2htnyopzpracc880sk4ko8ccogwkogkc48c8owco04ooccgwo0',
      client_secret: '267n0suwzp9co8kcgs80cscok84o8owo8cc0oogwc08s88ogck',
      grant_type: 'password',
      scope: 'api_public api_users',
      username,
      password
    };
    const token = CryptoJS.AES.encrypt(JSON.stringify(text), tokenPassword).toString();
    const query = {token, timestamp};

    return new Promise((resolve, reject) => {
        axios.post(`${API_FFF_HOST}/oauth/v2/token`, query)
            .then(
                response => {

                    if (response.data && response.data.access_token) {
                        const { access_token } = response.data;
                        document.cookie = `_ufa=${access_token};max-age=604800`;
                        resolve();
                    } else {
                        reject();
                    }
                }
            )
            .catch(() => reject())
    });
}

const mapStateToProps = ({connexionReducer}) => ({connexionReducer});

const mapDispatchToProps = dispatch => bindActionCreators({ initializeConnexion }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Connexion);